<template>
    <div class="custom-modal full-mobile active disable-click-outside" ref="modal" :class="{'align-start': !formSent}" tabindex="0" @keyup.esc="closeModal">
        <div class="custom-modal-content" :class="{'w-800': !formSent}">
            <div class="custom-modal-close"  @click="closeModal">
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.41503 1.14024C2.01528 0.759169 1.37464 0.76683 0.984114 1.15735C0.59359 1.54788 0.60107 2.17338 1.00082 2.55446L5.54386 6.88523L1.00082 11.216C0.60107 11.5971 0.59359 12.2226 0.984114 12.6131C1.37464 13.0036 2.01528 13.0113 2.41503 12.6302L6.99273 8.2664L11.4194 12.4862C11.8191 12.8673 12.4598 12.8596 12.8503 12.4691C13.2408 12.0786 13.2333 11.4531 12.8336 11.072L8.4416 6.88523L12.8336 2.69846C13.2333 2.31739 13.2408 1.69189 12.8503 1.30136C12.4598 0.910839 11.8191 0.903177 11.4194 1.28425L6.99273 5.50405L2.41503 1.14024Z" fill="#252525"/>
                </svg>
            </div>
            <div v-if="formSent" class="feedback-success">
                <h2 class="feedback-title -no-margin">Дякуємо за звернення!</h2>
                <p class="text-center feedback-success-text">Ваше питання успішно відправлено</p>
                <div class="text-center feedback-success-image">
                    <IconFeedbackSuccess/>
                </div>
            </div>
            <form :action="postUrl" class="feedback-content" @submit.prevent="submit" v-else method="post">
                <h2 class="feedback-title">Є питання? Напишіть нам</h2>
                <div class="feedback-part-title">Особисті дані</div>
                <FormInput v-model="formData.name" placeholder="Прізвище та ім’я*" isRequired="true"/>
                <div class="feedback-grid">
                    <FormInput v-model="formData.email" type="email" placeholder="Email*" isRequired="true"/>
                    <div>
                        <FormInput v-model="formData.phone" type="tel" placeholder="Телефон" v-mask="['+38 (###) ###-##-##']" isRequired="true"/>
                        <FormErrors v-if="formErrors.phone" :errors="formErrors.phone"/>
                    </div>
                </div>
                <div class="feedback-part-title">Інформація про звернення</div>
                <div class="feedback-options">
                    <button v-for="option in options"
                            class="feedback-option" :class="{active: option.id === activeOption}"
                            @click.prevent="changeOption(option.id)"
                    >
                        {{option.label}}
                    </button>
                </div>
                <div class="feedback-grid">
                    <div>
                        <FormDropdown :options="tourniquetList" label="Оберіть турнікет" type="tourniquet" :showLoader = isLoading
                                      v-if="activeOption === 'tourniquet' || activeOption === 'test'" placeholder="Не вибрано"
                                      :selectedDefault="chosenTourniquet"
                                      @setselection="setFormDataForTourniquet"
                                      @fetchlist="getTourniquetList(true)" @selecttourniquet="getTestList"/>
                        <FormErrors v-if="formErrors.tourniquet" :errors="formErrors.tourniquet"/>
                    </div>
                    <div>
                        <FormDropdown :options="testList" label="Оберіть тест" type="test" placeholder="Не вибрано" :selectedDefault="chosenTest"
                                      @setselection="setFormDataForTest"
                                      v-if="activeOption === 'test'"/>
                        <FormErrors v-if="formErrors.test" :errors="formErrors.test"/>
                    </div>
                </div>
                <div class="feedback-part-title">Ваш коментар</div>
                <textarea name="comment" id="comment" cols="30" rows="6" v-model="formData.comment" required class="feedback-area"></textarea>
                <div class="g-recaptcha" :data-sitekey="siteKey"></div>
                <FormErrors v-if="formErrors.captcha" :errors="formErrors.captcha"/>
                <div class="checkbox-block">
                    <FormCheckbox v-model="formData.personalData" name="personalData" isRequired="true" label="Я даю згоду на обробку і використання персональних даних"/>
                    <div v-if="formErrors.personalData && !formData.personalData" class="form-error">Ви маєте погодитись</div>
                </div>
                <button type="submit" class="btn btn-full">Надіслати</button>
            </form>
        </div>
    </div>
</template>

<script>
import FormInput from './helpers/FormInput.vue';
import {commonPageData} from '../common';
import FormCheckbox from './helpers/FormCheckbox.vue';
import FormDropdown from './helpers/FormDropdown.vue';
import {fetchUrl} from '../consts';
import IconFeedbackSuccess from './icons/IconFeedbackSuccess.vue';
import {mask} from 'vue-the-mask'
import FormErrors from './helpers/FormErrors.vue';

export default {
    props: [
        'postUrl',
        'siteKey',
        'csrfToken',
    ],
    name: "FeedbackForm",
    directives: {mask},
    components: {FormErrors, IconFeedbackSuccess, FormDropdown, FormCheckbox, FormInput},
    data() {
        return {
            formSent: false,
            tourniquetList: [],
            isLoading: false,
            testList: [],
            formData: {
                name: '',
                email: '',
                phone: '',
                comment: '',
                personalData: false,
                tourniquet: {},
                test: {},
                _token: this.csrfToken
            },
            formErrors: {},
            chosenTourniquet: null,
            chosenTest: null,
            sessionDataIsStored: false,
            activeOption: 'general',
            options: [
                {
                    id: 'general',
                    label: 'Загальне питання'
                },
                {
                    id: 'tourniquet',
                    label: 'Питання про турнікет'
                },
                {
                    id: 'test',
                    label: 'Питання про тестування'
                }
            ]
        }
    },
    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?hl=uk')
        document.head.appendChild(recaptchaScript);
        this.$refs.modal.focus();
        if (sessionStorage.getItem('feedBackData')) {
            this.sessionDataIsStored = true
            this.getSessionData();
        }
    },
    beforeDestroy() {
        document.querySelector('body').classList.remove('modal-open')
    },
    created() {
        setTimeout(function (){
            document.querySelector('body').classList.add('modal-open')
        }, 100)
        this.activeOption = commonPageData.feedbackFormOption;
        this.getTourniquetList();
        window.onbeforeunload = function(event) {
            sessionStorage.removeItem('feedBackData');
        };
    },
    watch: {
        formData: {
            handler(val){
                this.setSessionData(val);
            },
            deep: true
        }
    },
    methods: {
        changeOption(id) {
            this.activeOption = id;
            if(this.sessionDataIsStored) {
                this.getSessionData();
            }
        },
        getSessionData() {
            this.formData = JSON.parse(sessionStorage.getItem('feedBackData'));
            if(this.sessionDataIsStored) {
                this.tourniquetList = JSON.parse(sessionStorage.getItem('tourniquetList'))
            }
            this.chosenTourniquet = Object.keys(this.formData.tourniquet).length !== 0 ? this.tourniquetList.findIndex(item => item.alias === this.formData.tourniquet.alias) : null;
            if (this.chosenTourniquet && this.chosenTourniquet !== -1) {
                this.getTestList(this.tourniquetList[this.chosenTourniquet].id);
                this.chosenTest = this.testList.findIndex(item => item.id === this.formData.test.id);
            }
        },
        setSessionData(val) {
            sessionStorage.setItem('feedBackData', JSON.stringify(val))
        },
        submit() {
            this.formErrors = {};
            if(!this.formData.personalData) {
                this.formErrors.personalData = true
                return false
            }

            this.formData.questionType = this.activeOption;
            if (this.activeOption === 'general') {
                delete this.formData.tourniquet
                delete this.formData.test
            } else if (this.activeOption === 'tourniquet') {
                delete this.formData.test
            }
            this.formData.captcha = grecaptcha.getResponse();

            fetch(this.postUrl, {
                method: 'POST',
                    headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.formData)
            }).then(res => res.json())
            .then(res => {
                if(res.errors) {
                    this.formErrors = res.errors;
                    grecaptcha.reset()
                }
                this.formSent = res.status;
                sessionStorage.removeItem('feedBackData');
            }).catch((err) => {
                console.log(err);
            });
        },
        setFormDataForTest(id, text) {
            this.formData.test.id = id;
            this.formData.test.text = text;
            this.setSessionData(this.formData);
        },
        setFormDataForTourniquet(name, alias) {
            this.formData.tourniquet.name = name;
            this.formData.tourniquet.alias = alias;
            this.setSessionData(this.formData);
        },
        getTourniquetList(fetchData) {
            if(fetchData) {
                this.tourniquetList = [];
                this.isLoading = true;
                fetch(`${fetchUrl}api/v1/turnikets`).then(response => response.json())
                    .then(data => {
                        data.data.forEach(item => {
                            const tourniquetData = {
                                id: item.id,
                                alias: item.alias,
                                name: item.name,
                                manufacturer: item.manufacturer.name,
                                tests: item.tests
                            }
                            this.tourniquetList.push(tourniquetData);
                            this.isLoading = false;
                            const currentTourniquet = {
                                name: this.tourniquetList[0].name,
                                alias: this.tourniquetList[0].alias
                            }
                            sessionStorage.setItem('tourniquetList', JSON.stringify(this.tourniquetList))
                            this.formData.tourniquet = currentTourniquet;
                        });
                    })
            } else {
                if (commonPageData.list && commonPageData.list.length) {
                    commonPageData.list.forEach(item => {
                        const tourniquetData = {
                            id: item.id,
                            alias: item.alias,
                            name: item.name,
                            manufacturer: item.manufacturer.name,
                            tests: item.tests
                        }
                        this.tourniquetList.push(tourniquetData);
                    });
                } else if (commonPageData.tourniquetData) {
                    this.tourniquetList = [{
                        id: commonPageData.tourniquetData.id,
                        alias: commonPageData.tourniquetData.alias,
                        name: commonPageData.tourniquetData.name,
                        manufacturer: commonPageData.tourniquetData.manufacturer.name,
                        tests: commonPageData.tourniquetData.tests
                    }]
                    this.chosenTourniquet = 0;
                    this.formData.tourniquet.name = commonPageData.tourniquetData.name;
                    this.formData.tourniquet.alias = commonPageData.tourniquetData.alias;
                    this.getTestList(commonPageData.tourniquetData.id);
                    if (commonPageData.feedbackFormTest) {
                        this.chosenTest = this.testList.findIndex(item => item.id === commonPageData.feedbackFormTest);
                        this.formData.test.id = commonPageData.feedbackFormTest;
                        this.formData.test.text = this.getTestText(commonPageData.feedbackFormTest);
                    }
                }
            }
        },
        getTestText(id) {
            const test = this.testList.find(item => item.id === id);
            let orgs = [];
            test.organizations.forEach(org => orgs.push(org.name))
            let text = orgs.toString();
            text = text + ' ' + test.date + ' ' + test.resolution
            return text;
        },
        getTestList(id) {
            const index = this.tourniquetList.findIndex(item => item.id === id);
            this.testList = this.tourniquetList[index].tests;
        },
        closeModal() {
            commonPageData.feedbackFormshow = false
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";

.feedback {
    &-success {
        padding: 7.5rem 3rem;

        @include responsive-above($md) {
            width: 62rem;
        }

        &-image {
            margin-top: 4rem;
        }

        &-text {
            margin-top: 0.5rem;
            font-size: 1.6rem;
            color: #959595;
        }
    }

    &-content {
        padding: 0 5rem 2.5rem;

        @include responsive-below($md) {
            padding: 0;
        }
    }
    &-title {
        font-size: 3rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 7.5rem;

        @include responsive-below($lg) {
            margin-bottom: 4rem;
            padding: 0 4rem;
        }

        @include responsive-below($xs) {
            margin-bottom: 2.4rem;
            font-size: 2.4rem;
        }

        &.-no-margin {
            margin-bottom: 0;
        }
    }

    &-part {
        &-title {
            font-size: 1.6rem;
            margin-bottom: 1.4rem;
            margin-top: 3.6rem;
        }
    }

    &-option {
        flex: 1;
        text-align: center;
        color: #494B4E;
        font-family: 'Ukraine';
        font-size: 1.3rem;
        line-height: 1.5;
        padding: 0.8rem;
        background: transparent;
        border-radius: 4.1rem;
        border: 0;
        cursor: pointer;
        transition: color 0.3s, background-color 0.3s;

        &.active {
            color: #fff;
            background: #252525;
        }
    }

    &-options {
        display: flex;
        width: 100%;
        background: #F8F8F8;
        border-radius: 5.6rem;
        padding: 0.6rem;

        @include responsive-below($sm) {
            border-radius: 3rem;
            flex-direction: column;
        }
    }

    &-area {
        background: #F8F8F8;
        border: 1px solid #F8F8F8;
        border-radius: 0.8rem;
        width: 100%;
        resize: vertical;
        padding: 2rem;
        font-size: 1.5rem;
        font-family: 'Ukraine';
        margin-bottom: 2rem;

        &:focus {
            outline: none;
            border-color: $text-main;
        }
    }

    &-grid {
        display: grid;
        grid-template-columns: repeat(2,minmax(0,1fr));
        grid-gap: 2rem;

        @include responsive-below($sm) {
            grid-template-columns: repeat(1,minmax(0,1fr));
        }
    }
}

.checkbox {
    &-block {
        margin: 3rem 0 2.4rem;

        .checkbox-title {
            opacity: 0.7;
        }
    }
}
</style>
